import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from "framer-motion";
import '../styles/Header.css';
import Navbar from "./Navbar"
  
const Header = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <header ref={ref} className="header">
      <Navbar />
      {/* Background Image */}
      <motion.div 
    className="header-bg" 
    style={{ 
      y: backgroundY, 
      backgroundImage: 'url("cricket.webp")', 
      backgroundSize: 'cover', 
      backgroundPosition: 'center' 
    }} 
  />

  {/* Foreground Overlay */}
  <div className="header-overlay"></div>

      <div className="header-above">
        <div className="partners">
          <p>View Our Partners</p>
          <a href={`https://wa.me/918949471009`} className="partner-button">Click for websites</a>
        </div>
        <div className="logo">
          <img src="lightLogo.gif" alt="Mahadev Book Logo" className="header-cus-img" />
          <img src="cards.gif" alt="Mahadev Book Logo" className="header-cus-card" />
        </div>
        <div className="queries">
          <p>For Any Queries WhatsApp Us On</p>
          <a href={`https://wa.me/918949471009`} className="query-button">+44 7418 375763</a>
        </div>
      </div>

      <div className="header-below">
        <div className="content">
          <p className="quote">
          Imandari ek aisi daulat hai jo har kisi ke naseeb mein nahi hoti.
          </p>
          <h1 className="trusted">THE ULTIMATE TRUSTED PLATFORM</h1>
          <div className="whatsapp-info">
            <p>For New ID WhatsApp us on</p>
            <div className="whatsapp-numbers">
              <a href={`https://wa.me/918949471009`} className="number">+44 7418 375266</a> 
              <a href={`https://wa.me/918949471009`} className="number">+44 7476 885849</a>
            </div>
          </div>
        </div>
        <div className="image-content">
          <img src="players.webp" alt="sports" className="sports" />
        </div>
      </div>
    </header>
  );
};

export default Header;
